import { render, staticRenderFns } from "./hire.vue?vue&type=template&id=3aaaa1d0&scoped=true"
import script from "./hire.vue?vue&type=script&lang=js"
export * from "./hire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaaa1d0",
  null
  
)

export default component.exports